"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalGroup_1 = require("./ModalGroup");
exports.default = ModalGroup_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/ModalGroup/index.js
// module id = 658
// module chunks = 8